import type { WidgetConfiguration } from '@sg-widgets/shared-core';
import { SgwtWidgetName } from '../../../common/monitoring';
import { type WidgetEnvironment, type WidgetEnvironmentExtended, whichEnvironmentForAPI } from '../../../common/sgwt-widgets-utils';
import type { CommunicationType } from './communication.types';

// const HOMOLOGATION_API = 'http://localhost:9999/api/v1';
const DEVELOPMENT_API = 'https://sgwt-api-sgwt-help-center-dev.sgmarkets.world.socgen/api/v1';

// Homologation API, with or without SG APIM (for exposition)
const INTERNAL_HOMOLOGATION_API = 'https://sgwt-api-sgwt-help-center-uat.sgmarkets.world.socgen/api/v1';
const HOMOLOGATION_API = 'https://api-s-uat.sgmarkets.com/widget/webtoolkit/help-center/v1';

// Production API, with or without SG APIM (for exposition)
const INTERNAL_PRODUCTION_API = 'https://sgwt-api-sgwt-help-center.sgmarkets.world.socgen/api/v1';
const PRODUCTION_API = 'https://api-s.sgmarkets.com/widget/webtoolkit/help-center/v1';

// API Endpoints for configuration and knowledge base
export const API_ENDPOINTS: Record<WidgetEnvironmentExtended, string> = {
  development: `${DEVELOPMENT_API}/help-center`,
  internal_homologation: `${INTERNAL_HOMOLOGATION_API}/help-center`,
  homologation: `${HOMOLOGATION_API}/help-center`,
  internal_production: `${INTERNAL_PRODUCTION_API}/help-center`,
  production: `${PRODUCTION_API}/help-center`,
};

const COMMUNICATION_ENDPOINTS: Record<CommunicationType, Record<WidgetEnvironmentExtended, string>> = {
  mail: {
    development: `${DEVELOPMENT_API}/communication-hub/mail`,
    internal_homologation: `${INTERNAL_HOMOLOGATION_API}/communication-hub/mail`,
    homologation: `${HOMOLOGATION_API}/communication-hub/mail`,
    internal_production: `${INTERNAL_PRODUCTION_API}/communication-hub/mail`,
    production: `${PRODUCTION_API}/communication-hub/mail`,
  },
  unity: {
    development: `${DEVELOPMENT_API}/communication-hub/unity`,
    internal_homologation: `${INTERNAL_HOMOLOGATION_API}/communication-hub/unity`,
    homologation: `${HOMOLOGATION_API}/communication-hub/unity`,
    internal_production: `${INTERNAL_PRODUCTION_API}/communication-hub/unity`,
    production: `${PRODUCTION_API}/communication-hub/unity`,
  },
  impulse: {
    development: `${DEVELOPMENT_API}/communication-hub/impulse`,
    internal_homologation: `${INTERNAL_HOMOLOGATION_API}/communication-hub/impulse`,
    homologation: `${HOMOLOGATION_API}/communication-hub/impulse`,
    internal_production: `${INTERNAL_PRODUCTION_API}/communication-hub/impulse`,
    production: `${PRODUCTION_API}/communication-hub/impulse`,
  },
  feedback: {
    development: `${DEVELOPMENT_API}/feedback`,
    internal_homologation: `${INTERNAL_HOMOLOGATION_API}/feedback`,
    homologation: `${HOMOLOGATION_API}/feedback`,
    internal_production: `${INTERNAL_PRODUCTION_API}/feedback`,
    production: `${PRODUCTION_API}/feedback`,
  },
  mycases: {
    development: `${DEVELOPMENT_API}/communication-hub/mail`,
    internal_homologation: `${INTERNAL_HOMOLOGATION_API}/communication-hub/mail`,
    homologation: `${HOMOLOGATION_API}/communication-hub/mail`,
    internal_production: `${INTERNAL_PRODUCTION_API}/communication-hub/mail`,
    production: `${PRODUCTION_API}/communication-hub/mail`,
  },
  // No, but yes...
  none: {
    development: `${DEVELOPMENT_API}/communication-hub/mail`,
    internal_homologation: `${INTERNAL_HOMOLOGATION_API}/communication-hub/mail`,
    homologation: `${HOMOLOGATION_API}/communication-hub/mail`,
    internal_production: `${INTERNAL_PRODUCTION_API}/communication-hub/mail`,
    production: `${PRODUCTION_API}/communication-hub/mail`,
  },
};

export function getCommunicationEndpoint(type: CommunicationType, widgetConfiguration: WidgetConfiguration, applicationId?: string): string {
  const environment: WidgetEnvironmentExtended = whichEnvironmentForAPI(widgetConfiguration, SgwtWidgetName.HELP_CENTER);
  const endpoint = COMMUNICATION_ENDPOINTS[type][environment];
  return endpoint + (applicationId ? `?application-id=${applicationId}` : '');
}

/**
 * API for MyCases
 */
interface MyCasesEndpoints {
  api: string;
  portal: string;
}

export const MY_CASES_ENDPOINTS: Record<WidgetEnvironment, MyCasesEndpoints> = {
  development: {
    api: 'https://api-z-dev.sgmarkets.com/aks-uat-2/services/mycases/private/api/v1/cases/_do-search-cases',
    portal: 'https://mycases-uat-2.sgmarkets.com',
  },
  homologation: {
    api: 'https://api-z-dev.sgmarkets.com/aks-uat-2/services/mycases/private/api/v1/cases/_do-search-cases',
    portal: 'https://mycases-uat-2.sgmarkets.com',
  },
  production: {
    api: 'https://api-z.sgmarkets.com/services/mycases/private/api/v1/cases/_do-search-cases',
    portal: 'https://mycases.sgmarkets.com',
  },
};
